import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './71885248123504f5bea8ed8584f83a9cc254b46d8488d99bf30c994f973b0db0.cfe-internal.js';
import { useTabContext } from './b5923eed8d526568eb25cb083b9dff7921112e60363bcc0bcbf3cdeecbf709f9.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import Text from '../../utils/Text/d5bbdc70ae667ee4e5e35c7ec7f68ddc0e5d97496d8125c9344879c484725f9e.cfe-internal.js';

var _excluded = ["className", "label"];
var Tab = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    label = _ref.label,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTabContext = useTabContext(),
    active = _useTabContext.active,
    tabIndex = _useTabContext.tabIndex;
  return /*#__PURE__*/React__default.createElement(Text, _extends({}, rest, {
    lightTheme: true,
    ref: ref,
    className: classNames(className, styles.tab, _defineProperty({}, styles.active, active)),
    role: "tab",
    "aria-selected": active,
    tabIndex: tabIndex
  }), label);
});

export { Tab as default };
